export interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  title: string;
  description: string;
}

export interface CarGallery {
  title: string;
  packageDescription: string;
  images: GalleryImage[];
}

export interface CarGalleries {
  [key: string]: CarGallery;
}

export const carGalleries: CarGalleries = {
  'kia-sportage': {
    title: "Kia Sportage",
    packageDescription: "Kompleksowy detailing wnętrza",
    images: [
      {
        id: 1,
        src: "/lovable-uploads/b21d83e1-e710-4c90-83ff-fb782abc1de3.png",
        alt: "Kia Sportage - kierownica po detailingu",
        title: "Kia Sportage - kierownica",
        description: "Czyszczenie i pielęgnacja kierownicy"
      },
      {
        id: 2,
        src: "/lovable-uploads/3048751b-9f85-4ab4-93d9-e8b52f325bad.png",
        alt: "Kia Sportage - konsola centralna",
        title: "Kia Sportage - konsola centralna",
        description: "Detailing konsoli centralnej"
      },
      {
        id: 3,
        src: "/lovable-uploads/b5ee83ca-8f48-4401-962c-cde57f534783.png",
        alt: "Kia Sportage - wnętrze po detailingu",
        title: "Kia Sportage - wnętrze",
        description: "Kompleksowe czyszczenie wnętrza"
      },
      {
        id: 4,
        src: "/lovable-uploads/b5aa537d-7644-4a3c-83e8-65a624ea8386.png",
        alt: "Kia Sportage - tylne siedzenia",
        title: "Kia Sportage - tylne siedzenia",
        description: "Czyszczenie tylnych siedzeń"
      },
      {
        id: 5,
        src: "/lovable-uploads/2094a09f-7e0e-463d-b2ab-bb729273512a.png",
        alt: "Kia Sportage - detale wnętrza",
        title: "Kia Sportage - detale wnętrza",
        description: "Precyzyjne czyszczenie detali"
      },
      {
        id: 6,
        src: "/lovable-uploads/5db5550b-ba19-460b-88bd-8eca93c87734.png",
        alt: "Kia Sportage - zagłówek",
        title: "Kia Sportage - zagłówek",
        description: "Czyszczenie zagłówków"
      }
    ]
  },
  'skoda-rapid': {
    title: "Skoda Rapid",
    packageDescription: "Pakiet podstawowy 160 zł",
    images: [
      {
        id: 7,
        src: "/lovable-uploads/ff2d0f87-59ea-4bca-b6a3-cb26ff751ec0.png",
        alt: "Skoda Rapid - wnętrze przed czyszczeniem",
        title: "Skoda Rapid - stan przed czyszczeniem",
        description: "Wnętrze przed pakietem podstawowym 160 zł"
      },
      {
        id: 8,
        src: "/lovable-uploads/e35eb4bb-8cd3-4d6a-9121-7bb6a5c88634.png",
        alt: "Skoda Rapid - wnętrze po czyszczeniu",
        title: "Skoda Rapid - po odkurzaniu",
        description: "Efekt odkurzania i czyszczenia plastików"
      },
      {
        id: 9,
        src: "/lovable-uploads/c9bd4ed8-41d0-495c-a7f1-550b6d11def6.png",
        alt: "Skoda Rapid - kanapa tylna",
        title: "Skoda Rapid - kanapa tylna",
        description: "Tylna część auta przed odkurzaniem"
      },
      {
        id: 10,
        src: "/lovable-uploads/b7c75ad2-a2d7-431c-9978-952d18bd04a4.png",
        alt: "Skoda Rapid - tylne siedzenia po detailingu",
        title: "Skoda Rapid - tylne siedzenia po czyszczeniu",
        description: "Efekt pakietu podstawowego 160 zł"
      },
      {
        id: 11,
        src: "/lovable-uploads/316390e5-17f8-4f53-baf2-f2be2e944391.png",
        alt: "Skoda Rapid - kokpit",
        title: "Skoda Rapid - kokpit",
        description: "Czyszczenie deski rozdzielczej i plastików"
      },
      {
        id: 12,
        src: "/lovable-uploads/94766bc1-9774-4269-8ab2-bc3e6c68348a.png",
        alt: "Skoda Rapid - zegary",
        title: "Skoda Rapid - przyrządy",
        description: "Detailing elementów plastikowych"
      },
      {
        id: 13,
        src: "/lovable-uploads/8b8fbff4-e088-4fc3-b949-2e19b9d5b44d.png",
        alt: "Skoda Rapid - zegary czyste",
        title: "Skoda Rapid - zegary po czyszczeniu",
        description: "Czyszczenie wyświetlaczy"
      },
      {
        id: 14,
        src: "/lovable-uploads/ba8f9faf-8962-4e7f-8d27-4f45c13f1c08.png",
        alt: "Skoda Rapid - wnętrze po detailingu",
        title: "Skoda Rapid - finalny efekt",
        description: "Kompletne wnętrze po pakiecie 160 zł"
      }
    ]
  },
  'bmw-seria-1': {
    title: "BMW Serii 1",
    packageDescription: 'Pakiet "Ultra" 500 zł + pranie tapicerki',
    images: [
      {
        id: 15,
        src: "/lovable-uploads/1605cdd5-db44-442e-ac37-1f3357d1b740.png",
        alt: "BMW Serii 1 - wnętrze przednie po detailingu",
        title: "BMW Serii 1 - przednia część wnętrza",
        description: "Pakiet Ultra 500 zł - przednie fotele i kokpit"
      },
      {
        id: 16,
        src: "/lovable-uploads/46098e4b-d837-454a-a5ad-14bd1076f875.png",
        alt: "BMW Serii 1 - tylne siedzenia po praniu",
        title: "BMW Serii 1 - tylne siedzenia",
        description: "Pranie tapicerki - tylne siedzenia po czyszczeniu"
      },
      {
        id: 17,
        src: "/lovable-uploads/4dbd47fa-003f-4552-875d-4365f3291377.png",
        alt: "BMW Serii 1 - boczne siedzenie tylne",
        title: "BMW Serii 1 - boczne tylne siedzenie",
        description: "Detailing bocznych siedzeń tylnych"
      },
      {
        id: 18,
        src: "/lovable-uploads/6210fd0b-1ba0-40fd-a743-74e8ff4de9ff.png",
        alt: "BMW Serii 1 - kokpit i kierownica",
        title: "BMW Serii 1 - kokpit i kierownica",
        description: "Czyszczenie deski rozdzielczej i kierownicy"
      },
      {
        id: 19,
        src: "/lovable-uploads/10222895-e66b-4b69-a970-5b725e84118e.png",
        alt: "BMW Serii 1 - bagażnik po czyszczeniu",
        title: "BMW Serii 1 - bagażnik",
        description: "Odkurzanie i czyszczenie bagażnika"
      },
      {
        id: 20,
        src: "/lovable-uploads/b0507b24-b322-499f-9fc3-d81e7df617a4.png",
        alt: "BMW Serii 1 - przedni kokpit przed czyszczeniem",
        title: "BMW Serii 1 - kokpit przed czyszczeniem",
        description: "Stan kokpitu i wnętrza przed rozpoczęciem prac."
      },
      {
        id: 21,
        src: "/lovable-uploads/c5838731-82c7-450c-8bfb-809831db31c7.png",
        alt: "BMW Serii 1 - tylne siedzenia przed praniem",
        title: "BMW Serii 1 - tylne siedzenia przed praniem",
        description: "Tylne siedzenia kwalifikujące się do prania tapicerki."
      },
      {
        id: 22,
        src: "/lovable-uploads/9d84dd32-d2c0-45d5-9bc6-33b3a430857d.png",
        alt: "BMW Serii 1 - tyły foteli przed czyszczeniem",
        title: "BMW Serii 1 - tyły foteli przed czyszczeniem",
        description: "Stan tylnej części foteli przednich przed detailingiem."
      },
      {
        id: 23,
        src: "/lovable-uploads/faae1d2b-a41c-440d-8d0d-5005d015eefc.png",
        alt: "BMW Serii 1 - kanapa tylna przed praniem",
        title: "BMW Serii 1 - kanapa tylna przed praniem",
        description: "Widoczne zabrudzenia na tylnej kanapie przed czyszczeniem."
      },
      {
        id: 24,
        src: "/lovable-uploads/94021a59-8df0-490b-be20-ca5dc7ede5cb.png",
        alt: "BMW Serii 1 - wnętrze od strony kierowcy przed detailingiem",
        title: "BMW Serii 1 - kokpit przed czyszczeniem",
        description: "Wnętrze od strony kierowcy przed rozpoczęciem prac."
      }
    ]
  },
  'opel-mokka': {
    title: "Opel Mokka",
    packageDescription: 'Detailing "Premium" 500 zł + pranie foteli',
    images: [
      {
        id: 25,
        src: "/lovable-uploads/334eb184-8d1c-490b-9d88-e62c3186b460.png",
        alt: "Opel Mokka - wnętrze przed czyszczeniem",
        title: "Stan przed detailingiem",
        description: "Wnętrze Opla Mokka przed rozpoczęciem prac detailingowych."
      },
      {
        id: 26,
        src: "/lovable-uploads/acdad1d0-668f-425c-b4ab-ec346ab4b9dd.png",
        alt: "Opel Mokka - wnętrze po czyszczeniu",
        title: "Wnętrze po detailingu",
        description: "Kompleksowo wyczyszczona deska rozdzielcza i konsola centralna."
      },
      {
        id: 27,
        src: "/lovable-uploads/d6ead19c-b1fb-48e2-8ac9-ba293157ad34.png",
        alt: "Opel Mokka - tylne siedzenia przed praniem",
        title: "Tylne fotele przed praniem",
        description: "Zabrudzenia na tylnej kanapie przed praniem tapicerki."
      },
      {
        id: 28,
        src: "/lovable-uploads/a84f2f2e-0352-4948-b08d-6098a3cff60d.png",
        alt: "Opel Mokka - tylne siedzenia po praniu",
        title: "Tylne fotele po praniu",
        description: "Efekt prania tapicerki na tylnych siedzeniach."
      },
      {
        id: 29,
        src: "/lovable-uploads/b34a39b3-7e5e-409a-934e-997c0f6f184d.png",
        alt: "Opel Mokka - bagażnik przed czyszczeniem",
        title: "Bagażnik - stan przed",
        description: "Bagażnik przed odkurzaniem i czyszczeniem."
      },
      {
        id: 30,
        src: "/lovable-uploads/3de590b9-9912-451f-8e18-3c415b79898e.png",
        alt: "Opel Mokka - bagażnik po czyszczeniu",
        title: "Bagażnik - stan po",
        description: "Wyczyszczony i odkurzony bagażnik."
      },
      {
        id: 31,
        src: "/lovable-uploads/9201437a-7f19-4dbe-8024-94de4e7bde3b.png",
        alt: "Opel Mokka - konsola centralna przed czyszczeniem",
        title: "Detale wnętrza przed czyszczeniem",
        description: "Zabrudzenia w okolicach dźwigni zmiany biegów i podłokietnika."
      },
      {
        id: 32,
        src: "/lovable-uploads/02a826b5-046e-4c6f-b950-59319d835122.png",
        alt: "Opel Mokka - konsola centralna po czyszczeniu",
        title: "Nieskazitelna czystość detali",
        description: "Precyzyjnie wyczyszczone detale wnętrza po pakiecie Premium."
      },
       {
        id: 33,
        src: "/lovable-uploads/b5e9935d-dc64-473e-933c-0ac947fd4dd3.png",
        alt: "Opel Mokka - kierownica i zegary po detailingu",
        title: "Kierownica i zegary",
        description: "Czysta kierownica, zegary i elementy deski rozdzielczej."
      },
      {
        id: 34,
        src: "/lovable-uploads/32aadf10-778a-47d8-8b23-40c408939dd3.png",
        alt: "Opel Mokka w trakcie mycia aktywną pianą",
        title: "Mycie zewnętrzne",
        description: "Etap mycia zewnętrznego z użyciem aktywnej piany."
      }
    ]
  },
  'ford-transit': {
    title: "Ford Transit",
    packageDescription: "Pranie tapicerki w busie - 180 zł (efekty przed i po)",
    images: [
      {
        id: 35,
        src: "/lovable-uploads/6984f5ed-5aef-4978-b317-cbd62623378d.png",
        alt: "Ford Transit - fotele przed praniem",
        title: "Stan przed czyszczeniem",
        description: "Fotele w busie Ford Transit przed rozpoczęciem prania tapicerki."
      },
      {
        id: 36,
        src: "/lovable-uploads/434b68a6-42fb-4794-97a2-60b8c27b132e.png",
        alt: "Ford Transit - zabrudzenia na tapicerce",
        title: "Zbliżenie na plamy",
        description: "Widoczne zabrudzenia i plamy na siedzeniu przed praniem."
      },
      {
        id: 37,
        src: "/lovable-uploads/5426c969-72ca-4317-8edc-a601614addbc.png",
        alt: "Ford Transit - brudne siedzenie",
        title: "Siedzenie pasażera przed praniem",
        description: "Tapicerka wymagająca głębokiego czyszczenia."
      },
      {
        id: 38,
        src: "/lovable-uploads/d5e3d732-b890-49f1-89f3-9e6d1dc2073e.png",
        alt: "Ford Transit - fotele przed praniem tapicerki",
        title: "Ujęcie przed praniem tapicerki",
        description: "Fotele w busie Ford Transit przed rozpoczęciem prania tapicerki."
      },
      {
        id: 39,
        src: "/lovable-uploads/d99876d7-258b-4bcb-a20c-f9e220284cb0.png",
        alt: "Ford Transit - wnętrze po czyszczeniu",
        title: "Wnętrze po detailingu",
        description: "Ogólny widok na czyste wnętrze busa od strony kierowcy."
      },
      {
        id: 40,
        src: "/lovable-uploads/1c16c27c-2bd5-47a9-815e-49f8b619daee.png",
        alt: "Ford Transit - czyste siedzenia",
        title: "Fotele po praniu - inny kąt",
        description: "Rezultat prania tapicerki widoczny na siedzeniach."
      },
      {
        id: 41,
        src: "/lovable-uploads/f4f52aef-10e1-43af-924f-6d9e81b21f53.png",
        alt: "Ford Transit - odświeżone wnętrze",
        title: "Finalny wygląd foteli",
        description: "Kompleksowo wyprana tapicerka w Fordzie Transit."
      }
    ]
  },
  'seat-ibiza': {
    title: "Seat Ibiza",
    packageDescription: "Podstawowy detailing wnętrza za 149 zł",
    images: [
      {
        id: 42,
        src: "/lovable-uploads/4a2e12f7-076a-4486-b991-9292fcf1cd01.png",
        alt: "Seat Ibiza - stan przed detailingiem wnętrza",
        title: "Przed",
        description: "Zaniedbane wnętrze z widocznymi zabrudzenami na dywaniku i tapicerce"
      },
      {
        id: 43,
        src: "/lovable-uploads/cb3b8b79-ecef-48a2-90e4-81688b5e52cb.png",
        alt: "Seat Ibiza - dywaniki przed czyszczeniem",
        title: "Dywaniki - przed",
        description: "Mocno zabrudzone dywaniki wymagające gruntownego prania"
      },
      {
        id: 44,
        src: "/lovable-uploads/7f379431-226b-4f18-ad81-e0b444108806.png",
        alt: "Seat Ibiza - wnętrze po detailingu",
        title: "Po detailingu",
        description: "Idealnie wyczyszczone wnętrze z perfekcyjnie czystą deską rozdzielczą"
      },
      {
        id: 45,
        src: "/lovable-uploads/7fec96ac-57e1-4dc3-892e-fdbe753ee8b9.png",
        alt: "Seat Ibiza - efekt końcowy czyszczenia",
        title: "Efekt końcowy",
        description: "Doskonały rezultat podstawowego detailingu wnętrza"
      },
      {
        id: 46,
        src: "/lovable-uploads/fc7241b0-81ad-4b58-bc80-7b6ff325eb7e.png",
        alt: "Seat Ibiza - detale po czyszczeniu",
        title: "Detale po",
        description: "Każdy element wnętrza został dokładnie wyczyszczony i zabezpieczony"
      }
    ]
  },
  'kia-picanto': {
    title: "Kia Picanto",
    packageDescription: "Detailing wnętrza i pranie tapicerki za 480 zł",
    images: [
      {
        id: 47,
        src: "/lovable-uploads/5908d22b-9dc2-4422-a84c-4cf5b8637d4e.png",
        alt: "Kia Picanto - fotele przed praniem tapicerki",
        title: "Fotele - przed",
        description: "Fotele z materiału wymagające profesjonalnego prania tapicerki"
      },
      {
        id: 48,
        src: "/lovable-uploads/bf6ee96a-4516-4a08-87ca-a7799637fa94.png",
        alt: "Kia Picanto - tylne siedzenia przed czyszczeniem",
        title: "Tylne siedzenia - przed",
        description: "Tylne siedzenia z widocznymi plamami i zabrudzeniami"
      },
      {
        id: 49,
        src: "/lovable-uploads/8a0b3404-d0f6-48ab-9e6b-8f8b054d43e2.png",
        alt: "Kia Picanto - dywaniki po gruntownym czyszczeniu",
        title: "Dywaniki po czyszczeniu",
        description: "Perfekcyjnie wyczyszczone dywaniki i przestrzeń pod nogami"
      },
      {
        id: 50,
        src: "/lovable-uploads/88f496c7-8625-4d69-9202-42dc61d7df8f.png",
        alt: "Kia Picanto - wnętrze po kompletnym detailingu",
        title: "Wnętrze po detailingu",
        description: "Idealnie wyczyszczone wnętrze z odświeżoną tapicerką"
      },
      {
        id: 51,
        src: "/lovable-uploads/970f2be4-d3cb-4f53-94b0-43b1a64ccd29.png",
        alt: "Kia Picanto - efekt końcowy kompleksowego detailingu",
        title: "Efekt końcowy",
        description: "Doskonały rezultat detailingu wnętrza i prania tapicerki"
      }
    ]
  }
};

export const galleryFilters = [
  { id: "all", name: "Wszystkie", count: 51 },
  { id: "kia-sportage", name: "Kia Sportage", count: 6 },
  { id: "skoda-rapid", name: "Skoda Rapid", count: 8 },
  { id: "bmw-seria-1", name: "BMW Serii 1", count: 10 },
  { id: "opel-mokka", name: "Opel Mokka", count: 10 },
  { id: "ford-transit", name: "Ford Transit", count: 7 },
  { id: "seat-ibiza", name: "Seat Ibiza", count: 5 },
  { id: "kia-picanto", name: "Kia Picanto", count: 5 }
];
